import React from 'react'

const Result = ({ value: { guid, fullName, company, city, state } }) => {
  return (
    <div className='results-content'>
      <div className='name'><a href={guid}>{fullName}</a></div>
      <div className='company'>{company || <>&#8212;</>}</div>
      <div className='city'>{city || <>&#8212;</>}</div>
      <div className='state'>{state || <>&#8212;</>}</div>
    </div>
  )
}

export {
  Result
}
